import React from 'react';
import { Shield, TrendingUp, FileText, Briefcase } from 'lucide-react';
interface ServicesSectionProps {
  language: 'en' | 'es';
}
export function ServicesSection({
  language
}: ServicesSectionProps) {
  const services = [{
    icon: <FileText className="w-8 h-8 text-luxury-bg" data-id="element-254" />,
    titleEn: 'Tax Preparation & Planning',
    titleEs: 'Preparación y Planificación de Impuestos',
    descEn: 'Strategic tax planning for individuals and corporations to maximize wealth retention and ensure compliance.',
    descEs: 'Planificación fiscal estratégica para individuos y corporaciones para maximizar la retención de riqueza y asegurar el cumplimiento.',
    featuresEn: ['Corporate Taxes', 'Individual Returns', 'IRS Resolution'],
    featuresEs: ['Impuestos Corporativos', 'Declaraciones Individuales', 'Resolución IRS']
  }, {
    icon: <Shield className="w-8 h-8 text-luxury-bg" data-id="element-255" />,
    titleEn: 'Premium Insurance Solutions',
    titleEs: 'Soluciones de Seguros Premium',
    descEn: 'Comprehensive coverage portfolios tailored to protect your family, assets, and business legacy.',
    descEs: 'Portafolios de cobertura integral diseñados para proteger a su familia, activos y legado empresarial.',
    featuresEn: ['Life Insurance', 'Health Coverage', 'Business Protection'],
    featuresEs: ['Seguro de Vida', 'Cobertura de Salud', 'Protección Empresarial']
  }];
  return <section id="services" className="py-24 bg-luxury-alt relative" data-id="element-256">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-gold-primary/50 to-transparent" data-id="element-257" />
      <div className="absolute top-24 left-1/2 -translate-x-1/2 text-gold-primary/50 text-xs" data-id="element-258">
        ◆
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-259">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-260">
          <h2 className="font-sans text-sm font-bold text-gold-light tracking-[0.2em] uppercase mb-4" data-id="element-261">
            {language === 'en' ? 'Our Expertise' : 'Nuestra Experiencia'}
          </h2>
          <h3 className="font-serif text-4xl md:text-5xl text-warm-white mb-6 leading-tight" data-id="element-262">
            {language === 'en' ? 'Exclusive Financial Solutions' : 'Soluciones Financieras Exclusivas'}
          </h3>
          <p className="text-warm-gray text-lg" data-id="element-263">
            {language === 'en' ? 'Tailored strategies designed for those who demand excellence in their financial and insurance portfolio.' : 'Estrategias a medida diseñadas para quienes exigen excelencia en su portafolio financiero y de seguros.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 max-w-5xl mx-auto" data-id="element-264">
          {services.map((service, index) => <div key={index} className="group relative bg-luxury-card rounded-xl p-1 transition-all duration-500 hover:shadow-gold-glow" data-id="element-265">
              {/* Subtle gold gradient top border effect */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gold-gradient rounded-t-xl opacity-80" data-id="element-266" />

              <div className="bg-luxury-card h-full rounded-lg p-8 sm:p-10 border border-gold-dark/10 relative overflow-hidden" data-id="element-267">
                {/* Background glow on hover */}
                <div className="absolute -top-24 -right-24 w-48 h-48 bg-gold-primary/10 rounded-full blur-3xl group-hover:bg-gold-primary/20 transition-colors duration-500" data-id="element-268" />

                {/* Icon in Gold Circle */}
                <div className="w-16 h-16 rounded-full bg-gold-gradient flex items-center justify-center mb-8 shadow-gold-glow-strong" data-id="element-269">
                  {service.icon}
                </div>

                <h4 className="font-serif text-2xl sm:text-3xl text-warm-white mb-4" data-id="element-270">
                  {language === 'en' ? service.titleEn : service.titleEs}
                </h4>

                <p className="text-warm-gray mb-8 leading-relaxed" data-id="element-271">
                  {language === 'en' ? service.descEn : service.descEs}
                </p>

                <ul className="space-y-4" data-id="element-272">
                  {(language === 'en' ? service.featuresEn : service.featuresEs).map((feature, idx) => <li key={idx} className="flex items-center text-warm-white/90 font-medium" data-id="element-273">
                      <span className="text-gold-primary mr-3 text-xs" data-id="element-274">◆</span>
                      {feature}
                    </li>)}
                </ul>

                <div className="mt-10 pt-8 border-t border-gold-dark/20" data-id="element-275">
                  <a href="#contact" className="inline-flex items-center text-gold-light font-bold uppercase tracking-widest text-sm hover:text-warm-white transition-colors" data-id="element-276">
                    {language === 'en' ? 'Learn More' : 'Conocer Más'}
                    <TrendingUp className="w-4 h-4 ml-2" data-id="element-277" />
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}